import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'paginator',
  template: require('./paginator.component.html'),
  styles: [require('./paginator.component.scss')],
})
export class PaginatorComponent {
  @Input() current: number;
  @Input() total: number;
  @Output() indexEmitter = new EventEmitter<number>();

  public loadPrevious(current: number, emitter: EventEmitter<number>): void {
    if (current + 1 === 1) return;
    emitter.emit(current - 1);
  }

  public loadNext(current: number, total: number, emitter: EventEmitter<number>): void {
    if (current + 1 === total) return;
    emitter.emit(current + 1);
  }
}
